import { render, staticRenderFns } from "./MySpaceTasksWidgets.vue?vue&type=template&id=6a0c65a0&scoped=true&"
import script from "./MySpaceTasksWidgets.vue?vue&type=script&lang=js&"
export * from "./MySpaceTasksWidgets.vue?vue&type=script&lang=js&"
import style0 from "./MySpaceTasksWidgets.vue?vue&type=style&index=0&id=6a0c65a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0c65a0",
  null
  
)

export default component.exports